import { Divider as DividerAD } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';

import styles from './divider.module.css';

type P = {
  marginNone?: boolean;
} & ComponentProps<typeof DividerAD>;

const Divider = ({ className, marginNone, ...rest }: P) => (
  <DividerAD
    className={cn(className, {
      [styles['margin-none'] ?? '']: Boolean(marginNone),
    })}
    {...rest}
  />
);

export default Divider;
